<template>
<!-- 解释与说明 -->
  <div class="question-explain">
    <div class="exde">
      <i class="exIcon" :class='{"isios": isIos}'></i><span class="edetail">{{explain}}</span>
    </div>
  </div>
</template>

<script>
import {isAndroid} from '@/libs/utils'
export default {
  name: 'QuestionExplain',
  props: ['explain'],
  computed: {
    isIos() {
      return !isAndroid();
    }
  },
  mounted() {
    // console.log(this.explain);
  }
}
</script>

<style lang="scss" scoped>
@import '~@/common/scss/const.scss';
@import '~@/common/scss/mixin.scss';

.question-explain {
  @include box-sizing(content-box);
  margin-top: pxToRem(15);
  line-height: 20px;
  font-size: 12px;
  color:rgba(133,191,252,1);
  .exde {
    display: inline-block;
    width: 100%;
    text-align: left;
    .exIcon {
      display: inline-block;
      width: 14px;
      height: 14px;
      background:url('./images/icon.png') no-repeat center center;
      background-size: 100% 100%;
      background-origin: center center;
      vertical-align: text-bottom;
      &.isios {
        vertical-align: text-top;
      }
    }
    .edetail {
      padding-left: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionExplain/QuestionExplain.vue